import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';

import { StatusProgressionComponent } from '../../molecules';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'shared-app-status-bar',
  standalone: true,
  imports: [StatusProgressionComponent, TranslatePipe],
  templateUrl: './app-status-bar.component.html',
  styleUrl: './app-status-bar.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppStatusBarComponent {
  step = input.required<number>();
  timeInMinutes = input<number>();
}
